import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef } from 'react';
type LoadedDataset = DOMStringMap & {
  loaded?: string;
};
const setLoadedFlag = (element: HTMLElement, value: 'true' | 'false') => {
  (element.dataset as LoadedDataset).loaded = value;
};
const ensureLoadedFlag = (element: HTMLElement) => {
  const dataset = element.dataset as LoadedDataset;
  dataset.loaded = dataset.loaded ?? 'false';
};
interface PhotoLoadTracker {
  markLoaded: (index: number) => void;
  registerImage: (index: number) => (node: HTMLImageElement | null) => void;
  registerOverlay: (index: number) => (node: HTMLDivElement | null) => void;
}
export function usePhotoLoadTracker() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Map();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const overlayReferences = useRef(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Map();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const imageReferences = useRef(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = index => {
      const overlay = overlayReferences.current.get(index);
      const image = imageReferences.current.get(index);
      if (!(overlay || image)) {
        return;
      }
      const apply = () => {
        if (overlay) {
          setLoadedFlag(overlay, "true");
        }
        if (image) {
          setLoadedFlag(image, "true");
        }
      };
      if (globalThis.window === undefined || typeof globalThis.requestAnimationFrame !== "function") {
        apply();
        return;
      }
      globalThis.requestAnimationFrame(apply);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const markLoaded = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = index_0 => node => {
      const map = overlayReferences.current;
      if (node) {
        ensureLoadedFlag(node);
        map.set(index_0, node);
      } else {
        map.delete(index_0);
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const registerOverlay = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = index_1 => node_0 => {
      const map_0 = imageReferences.current;
      if (node_0) {
        map_0.set(index_1, node_0);
        if (node_0.complete) {
          setLoadedFlag(node_0, "true");
          markLoaded(index_1);
        } else {
          ensureLoadedFlag(node_0);
        }
      } else {
        map_0.delete(index_1);
      }
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const registerImage = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      registerOverlay,
      registerImage,
      markLoaded
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}